<template>
  <footer class="c-footer">
    <div v-if="siteData" class="c-footer__left" :style="{'background-color': `#${siteData.keycolor}`}">
      <div class="c-catalogue">
        <div class="c-catalogue__image">
          <img :src="siteData.cover" alt="" width="750" height="1174" />
        </div>
        <p class="c-catalogue__title">
          <span v-if="siteData">{{siteData.sitename}}</span>
        </p>
      </div>
    </div>
    <div class="c-footer__right">
      <button class="c-btnTop" @click="gotoTop">
        <span></span>
      </button>
      <div class="c-cr">
        <a href="https://www.pearlygates.net/">
          <img src="assets/img/common/logo@2x.png" alt="PEARLY GATES" width="159" height="20" />
        </a>
        <small>Copyright © TSI Inc. All Rights Reserved.</small>
      </div>
    </div>
  </footer>
</template>

<script>
import {gsap, Power3} from 'gsap/all';

export default {
  data() {
    return {
      siteData: null,
    }
  },
  computed: {
  },
  mounted() {
    this.siteData = this.$store.getters.siteData;
    // console.log(this.siteData);
  },
  methods: {
    gotoTop() {
      gsap.to(window, {duration: 1.2, scrollTo: {y: 0, autoKill: false}, ease: Power3.easeInOut});
    }
  }
}
</script>